import Auth from '../auth/Auth';
import BidPeriodFileImportRequestInfo from '../models/BidPeriodFileImportRequestInfo';
import ApiDocument from './ApiDocument';
import { WebClient } from './WebClient'

class ApiIETrips extends WebClient {
    async getCurrentBidPeriod(): Promise<BidPeriodFileImportRequestInfo> {
        const url = "/bidperiod";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async queueServiceRequest(): Promise<BidPeriodFileImportRequestInfo> {
        return ApiDocument.queueServiceRequest("ie-trips");
    }

    async getLastRequest(): Promise<BidPeriodFileImportRequestInfo> {
        const url = "/document/lastrun/ie-trips";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }
}

export default new ApiIETrips();
